import { NgModule } from "@angular/core";
import { UiStringTemplateOutletDirective } from "./directives/string-template-outlet.directive";

@NgModule({
  exports: [UiStringTemplateOutletDirective],
  imports: [UiStringTemplateOutletDirective],
})
export class UiOutletModule {}
